import Button from "@/Components/Button/Button";
import { useSetModal } from "@/shared/atoms/useModal";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { flags } from "../Maps/KioskLanguage";
import Kiosk from "./Kiosk";
import KioskBackgroundSlider from "./KioskBackgroundSlider";
import useKioskTranslation from "./useKioskTranslation";

const KioskStartScreen = () => {
  const { t } = useKioskTranslation();
  const { t: tRoot, i18n } = useTranslation("");
  const setModal = useSetModal();
  const flagSrc = flags[i18n.language as keyof typeof flags];

  return (
    <Kiosk>
      <div className="relative h-screen w-full">
        <Link to="/kiosk/deliverymethods">
          <KioskBackgroundSlider>
            <h1 className="m-20 text-center text-[96px] font-black tracking-[2px] text-white">
              {t("orderHere")}
            </h1>
            <button className="mt-10 min-h-[92px] min-w-[340px] rounded-[18px] border-none bg-(--order_now_button_color) px-16 py-7 text-[30px] font-extrabold text-(--order_now_button_text_color) transition-transform duration-150 ease-in active:scale-[0.97]">
              {t("startOrder")}
            </button>
          </KioskBackgroundSlider>
        </Link>
        <div className="absolute right-10 bottom-10 z-[60] w-[28rem]">
          <div className="relative">
            <Button onClick={() => setModal("kioskLanguages")} size="large">
              {flagSrc && (
                <div
                  className="left-[3rem] top-[50%] absolute"
                  style={{ transform: "translate(-50%, -50%)" }}
                >
                  <img
                    src={flagSrc}
                    alt={`${i18n.language} flag`}
                    className="block w-[3rem]"
                  />
                </div>
              )}
              <div className="mx-auto">
                {tRoot(`languages.${i18n.language}`)}
              </div>
            </Button>
          </div>
        </div>
      </div>
    </Kiosk>
  );
};

export default KioskStartScreen;
